export default "https://assets.egbcdn.net/assets/packs/_/images/app/app-mob-992100aebb5772717d7ad34e1559d193.png";